import { PlatformCompanyUserListOrderFields } from "@generated/graphql";
import dayjs from "dayjs";
import { ColumnConfig } from "layout/TableConstructor/types";
import TeamMemberActions from "../TeamMemberActions";
import TeamMemberEmployee from "../TeamMemberEmployee";
import TeamMemberRoleSelect from "../TeamMemberRoleSelect";
import TeamMemberStatus from "../TeamMemberStatus";
import { TeamMember, TeamMembersFilter } from "./types";

type ColumnConfigProps = {
  inviteTokens: Map<string, string>;
  isInvitesLoading: boolean;
};

const getColumnConfig = ({
  inviteTokens,
  isInvitesLoading,
}: ColumnConfigProps): ColumnConfig<TeamMember, TeamMembersFilter, PlatformCompanyUserListOrderFields, undefined>[] => [
  {
    name: "employee",
    title: "Сотрудник",
    sortField: PlatformCompanyUserListOrderFields.UserEmailUserLastName,
    render: (employee) => <TeamMemberEmployee employee={employee} />,
  },
  {
    name: "role",
    title: "Роль",
    sortField: PlatformCompanyUserListOrderFields.Role,
    render: (employee) => <TeamMemberRoleSelect employee={employee} />,
  },
  {
    name: "status",
    title: "Статус",
    sortField: PlatformCompanyUserListOrderFields.Status,
    render: (employee) => <TeamMemberStatus status={employee.status} />,
  },
  {
    name: "createdAt",
    title: "Добавлен",
    sortField: PlatformCompanyUserListOrderFields.CreatedAt,
    render: (employee) => dayjs(employee.createdAt).format("DD.MM.YYYY"),
  },
  {
    name: "action",
    title: "",
    isHiddenInSettings: true,
    render: (employee) =>
      !employee.isCreator && (
        <TeamMemberActions
          employee={employee}
          inviteToken={inviteTokens.get(employee.userEmail.email)}
          isInvitesLoading={isInvitesLoading}
        />
      ),
    cellStyle: {
      width: 48,
      textAlign: "right",
    },
  },
];

export default getColumnConfig;
